import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4995f08c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popover-title"
};
const _hoisted_2 = {
  class: "flag-container"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remove", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ID"
}, " Profile ID", -1));
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "provider-id"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ID"
}, "DSP provider id", -1));
const _hoisted_10 = {
  class: "provider-id"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ID"
}, "Advertiser ID", -1));
const _hoisted_12 = {
  key: 2,
  class: "reauthenticate-container"
};
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connection expired", -1));
const _hoisted_15 = {
  class: "advertising-account-with-flag"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
  class: "country"
};
const _hoisted_19 = {
  style: {
    "align-items": "center",
    "display": "flex"
  }
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this account ? ", -1));
const _hoisted_21 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_app_modal = _resolveComponent("app-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [!$data.accountDeleteModal ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
    key: 0,
    width: "fit-content",
    click: $data.showPopOver,
    "custom-class": `advertising-account-with-flag-popover ${$options.statusState} ${$options.isAdsAccount ? 'is-ad-account' : 'is-dsp-account'}`,
    delay: {
      show: 0,
      hide: 100
    }
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
      class: "flag",
      src: _ctx.getCountryFlag($options.getProfileCountryCode()),
      alt: $options.getProfileCountryCode()
    }, null, 8, _hoisted_3), _createElementVNode("span", null, _toDisplayString($options.advertiserNameOrCountry), 1)]), !$data.removeLoading && !_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
      class: "remove-button",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onAccountDelete && $options.onAccountDelete(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "remove-connection",
      color: "#FF8F94"
    }), _hoisted_5])])) : _createCommentVNode("", true)])]),
    content: _withCtx(() => [$options.isAdsAccount ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["popover-content", $options.statusState])
    }, [_hoisted_6, _createVNode(_component_wrap_with_copy, {
      class: "profile-id"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.profile.account_id), 1)]),
      _: 1
    })], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
      class: _normalizeClass(["profile-id-container", $options.statusState])
    }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_wrap_with_copy, {
      class: "profile-id"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.profile.amazon_dsp_profile_id), 1)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_wrap_with_copy, {
      class: "profile-id"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.profile.account_id), 1)]),
      _: 1
    })])], 2)])), $options.statusState === 'inactive' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
      icon: "connection-expired"
    }), _hoisted_14]), _createElementVNode("div", {
      class: "reauthenticate-button",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.onAccountReAuthenticate && $options.onAccountReAuthenticate(...args))
    }, "Reauthenticate")])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(['advertising-account-with-flag', $options.statusState]),
      onMouseenter: _cache[3] || (_cache[3] = (...args) => $options.onMouseEnter && $options.onMouseEnter(...args)),
      onMouseleave: _cache[4] || (_cache[4] = (...args) => $options.onMouseLeave && $options.onMouseLeave(...args))
    }, [_createElementVNode("div", _hoisted_15, [$data.removeLoading ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "loading"
    })) : !$data.removeLoading && !$data.isHovered ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      class: "flag",
      src: _ctx.getCountryFlag($options.getProfileCountryCode()),
      alt: $options.getProfileCountryCode()
    }, null, 8, _hoisted_16)) : !$data.removeLoading && $data.isHovered && _ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("img", {
      key: 2,
      class: "flag",
      src: _ctx.getCountryFlag($options.getProfileCountryCode()),
      alt: $options.getProfileCountryCode()
    }, null, 8, _hoisted_17)) : _createCommentVNode("", true), !$data.removeLoading && !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 3,
      icon: "remove-connection",
      color: "#616161",
      onClick: $options.onAccountDelete
    }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "advertising-account-with-flag",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.onClickCountryCode && $options.onClickCountryCode(...args))
    }, [_createElementVNode("div", _hoisted_18, _toDisplayString($options.getProfileCountryCode()), 1), _createElementVNode("div", _hoisted_19, [$options.statusState === 'inactive' ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "connection-expired"
    })) : _createCommentVNode("", true)])])], 34)]),
    _: 1
  }, 8, ["click", "custom-class"])) : _createCommentVNode("", true), $props.profile ? (_openBlock(), _createBlock(_component_app_modal, {
    key: 1,
    modelValue: $data.accountDeleteModal,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.accountDeleteModal = $event),
    title: "Confirm Account Delete",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: $options.onAccountDeleteConfirm
  }, {
    default: _withCtx(() => [_hoisted_20, _createElementVNode("p", null, [_createTextVNode(_toDisplayString($props.profile?.name) + " " + _toDisplayString($props.profile?.account_id) + " " + _toDisplayString($props.profile?.account_provider) + " " + _toDisplayString($options.getProfileCountryCode($props.profile)) + " ", 1), _createElementVNode("img", {
      class: "flag",
      src: _ctx.getCountryFlag($options.getProfileCountryCode($props.profile)),
      alt: $options.getProfileCountryCode($props.profile)
    }, null, 8, _hoisted_21)])]),
    _: 1
  }, 8, ["modelValue", "onOk"])) : _createCommentVNode("", true)], 64);
}